import React from 'react'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import SelectCannedReply from '../emailer/select_canned_reply'

class Smser extends React.Component {

  setContent = (el) => {
    this.contentEl = el
  }

  onChange = () => {
    this.props.store.emit('ui:lead:smser:content', this.contentEl.value)
  }

  onInsertCannedReply = (body) => {
    const el = this.contentEl

    if (!el) {
      this.props.store.emit('ui:lead:smser:content', (this.props.value || '') + body)
      return
    }

    const start = el.selectionStart
    const end = el.selectionEnd
    const value = el.value
    const next = value.slice(0, start) + body + value.slice(end)

    this.props.store.emit('ui:lead:smser:content', next)

    const caret = start + body.length
    window.requestAnimationFrame(() => {
      el.focus()
      el.setSelectionRange(caret, caret)
    })
  }

  onSend = () => {
    this.props.store.emit('lead:sms:create')
  }

  onClose = () => {
    this.props.store.emit('lead:sms:close')
  }

  render() {
    return (
      <div className="grid gap-4 p-6 pt-4">
        <div className="grid gap-2">
          <Textarea rows="6" placeholder="Write an SMS message..." ref={this.setContent} value={this.props.value} onChange={this.onChange}/>
          <span className="text-xs text-muted-foreground">{(this.props.value || '').length} characters (max. 640)</span>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <SelectCannedReply onSelect={this.onInsertCannedReply} />
          <div className="flex justify-end gap-2">
            <Button variant="outline" size="sm" onClick={this.onClose}>Cancel</Button>
            <Button size="sm" onClick={this.onSend}>Send SMS</Button>
          </div>
        </div>
      </div>
    )
  }
}

export default Smser
